module.exports = __webpack_public_path__ + "static/media/cost_white.83e69977.svg";